import * as React from 'react';
import IIconProps, { IconInfo } from '../entities/IIconProps';
import Icon from '../components/Icon';

export default function GetIconComponent(iconInfo: IconInfo, props?: IIconProps) {
	return iconInfo ? (
		<Icon
			{...props}
			name={iconInfo.id}
			size={iconInfo.size}
		/>
	) : (
		<></>
	);
}
